import { render, staticRenderFns } from "./CreateNavigationDialog.vue?vue&type=template&id=0c398c5f&scoped=true&lang=pug&"
import script from "./CreateNavigationDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateNavigationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c398c5f",
  null
  
)

export default component.exports